import { GET_FEETYPES, OPEN_FEE, CLOSE_FEE, GET_AUTOCOMPLETE, GET_AUTOCOMPLETE2, GET_MOREAUTOCOMPLETE, GET_MOREAUTOCOMPLETE2 } from '../actions/types'

export default function personsReducer(state = {}, action) {
  switch (action.type) {
    case GET_FEETYPES:
      return {...state, feetypes: action.feetypes}
    case OPEN_FEE:
      return {...state, thisfee: action.fee}
    case CLOSE_FEE:
      delete state.thisfee
      return {...state}
    case GET_AUTOCOMPLETE:
      return {...state, autocomplete: action.payload}
    case GET_MOREAUTOCOMPLETE:
      return {
        ...state,
        autocomplete: state.autocomplete.concat(action.payload)
      }
    case GET_AUTOCOMPLETE2:
      return {...state, autocomplete2: action.payload}
    case GET_MOREAUTOCOMPLETE2:
      return {
        ...state,
        autocomplete2: state.autocomplete2.concat(action.payload)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fees_reducer.js